export const STATUS = {
  FAILURE: -1,
  INCOMPLETE: 0,
  SUCCESS: 1,
};

export const EMAIL_REGEX =
  /^([\w\d-!?=&{}^`/*#|~$'+%]+\.?)*[\w\d-!?=&{}^`/*#|~$'+%]+@[\w\d]{2,}(\.[\w\d]{2,})+$/i;
